module.exports = __webpack_public_path__ + "img/gh-305em-01.prt.b52e7436.jpg";